import { render, staticRenderFns } from "./moreAssistant.vue.js?vue&type=template&id=98062cfa&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./moreAssistant.vue?vue&type=template&id=98062cfa&scoped=true"
import script from "./moreAssistant.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./moreAssistant.vue?vue&type=script&lang=js"
export * from "./moreAssistant.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./moreAssistant.vue?vue&type=script&lang=js"
import style0 from "./moreAssistant.vue.scss?vue&type=style&index=0&id=98062cfa&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./moreAssistant.vue?vue&type=style&index=0&id=98062cfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98062cfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98062cfa')) {
      api.createRecord('98062cfa', component.options)
    } else {
      api.reload('98062cfa', component.options)
    }
    module.hot.accept("./moreAssistant.vue.js?vue&type=template&id=98062cfa&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./moreAssistant.vue?vue&type=template&id=98062cfa&scoped=true", function () {
      api.rerender('98062cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/offline/moreAssistant.vue"
export default component.exports